import React from 'react';
import { Link } from 'react-router-dom';
import styles from './PageHeader.module.scss';
import Title from '../TitleStyles/title';
import { BimloaFilter, FilterField } from '../BimloaFilter/BimloaFilter';
import Button from '../Button/Button';
import { Option } from '../DropDown/DropDown';

interface PageHeaderProps {
  title: string;
  filterFields?: FilterField[];
  filters?: Record<string, Option>;
  setFilters?: (filters: Record<string, Option>) => void;
  linkTo?: string;
  buttonText?: string;
  buttonWidth?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  filterFields,
  filters,
  setFilters,
  linkTo,
  buttonText,
  buttonWidth,
}) => {
  const buttonStyle = {
    '--button-width': buttonWidth || '233px',
  } as React.CSSProperties;

  return (
    <div className={styles.headerRow}>
      <Title MainTitle={title} />
      <div className={styles.toolsRow}>
        {filterFields && filters && setFilters && (
          <BimloaFilter fields={filterFields} values={filters} onChange={setFilters} />
        )}
        {linkTo && (
          <div className={styles.toolsRowActions}>
            <Link to={linkTo} style={{ textDecoration: 'none' }}>
              <Button className={styles.button} style={{ ...buttonStyle, height: '44px' }}>
                {buttonText}
              </Button>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
